interface Exception {
    code: string;
    message: string;
}

interface Error {
    extensions: {
        exception: {
            body: Exception;
        };
        code: string;
    };
    message: string;
}

function getErrorCodeFromGraphQLException(error: Error): string {
    try {
        // Error code will be more specific with body
        return error.extensions.exception.body.code;
    } catch (e) {
        // internal error does not have exception field.
        return error.extensions.code;
    }
}

function getErrorFromGraphQLException(error: Error): Exception {
    let code, message;

    try {
        // Error code will be more specific with body
        ({ code, message } = error.extensions.exception.body);
    } catch (e) {
        // internal error does not have exception field.
        code = error.extensions.code;
        message = error.message;
    }

    return {
        code,
        message,
    };
}

export { getErrorCodeFromGraphQLException, getErrorFromGraphQLException };
